(function () {
    'use strict';

    angular.module('swif.patrimoine')
    .config(route)
    .factory('swifCadastreService',swifCadastreService);


    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/patrimoine/cadastre/table_view', {
            templateUrl: 'partials/patrimoine/cadastre_table_view.html',
            controller: PatrimoineCadastreController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifCadastreService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }

    /**
        * @ngdoc service
        * @name swif.patrimoine.swifCadastreService
        * @requires swif.framework.swifFrameworkService
        * @description provide api to handle cadastre related data
    **/
    function swifCadastreService($q, swif) {
        'ngInject';
        var service = {};
        service.getCollection = function (id) {
            return swif.collections.getCollection(id);
        };
        service.resolveData = function () {
            return swif.route.check().then(function () {
                var promises = [];
                promises.push(service.createCollection('patrimoine_cadastre_commune'));
                promises.push(service.createCollection('patrimoine_cadastre_section'));
                promises.push(service.createCollection('patrimoine_cadastre_feuille'));
                return $q.all(promises).then((results) => {
                    var data = {};
                    data.communes = results[0];
                    data.sections = results[1];
                    data.feuilles = results[2];
                    return data;
                });
            });
        };
        service.createCollection = function (type) {
            var filter = {};
            swif.data.sortOn(filter, 'name', 'ASC');
            return swif.collections.createOrUpdate(
                type,
                type,
                filter,
                {limitPerPage: 0}
            );
        };
        service.preModal = function (data) {
            if (data.action.id === 'add') {
                data.model = {};
            }
        };
        service.preValidateCommunes = function (data) {
            return service.getCollection('patrimoine_cadastre_commune')
            .preValidate(data);
        };
        service.callbackCommunes = function (error, data) {
            service.getCollection('patrimoine_cadastre_commune')
            .callback(error, data);
        };
        service.preValidateFeuilles = function (data) {
            return service.getCollection('patrimoine_cadastre_feuille')
            .preValidate(data);
        };
        service.callbackFeuilles = function (error, data) {
            service.getCollection('patrimoine_cadastre_feuille')
            .callback(error, data);
        };
        service.preValidateSections = function (data) {
            return service.getCollection('patrimoine_cadastre_section')
            .preValidate(data);
        };
        service.callbackSections = function (error, data) {
            service.getCollection('patrimoine_cadastre_section')
            .callback(error, data);
        };
        return service;
    }

    function PatrimoineCadastreController($scope, $q, $location, swif, patrimoine, data) {
        'ngInject';
        var cadastre = patrimoine.cadastre;
        console.log('init PatrimoineCadastreController');
        $scope.importui = $location.search().importui ? true : false;
        $scope.communes = data.communes;
        $scope.sections = data.sections;
        $scope.feuilles = data.feuilles;
        $scope.preModalCommunes = cadastre.preModal;
        $scope.preValidateCommunes = cadastre.preValidateCommunes;
        $scope.callbackCommunes = cadastre.callbackCommunes;

        $scope.preModalSections = cadastre.preModal;
        $scope.preValidateSections = cadastre.preValidateSections;
        $scope.callbackSections = cadastre.callbackSections;

        $scope.preModalFeuilles = cadastre.preModal;
        $scope.preValidateFeuilles = cadastre.preValidateFeuilles;
        $scope.callbackFeuilles = cadastre.callbackFeuilles;

        $scope.data = {
            sections: '',
            feuilles: ''
        };
        $scope.extractSections = 'var s = document.querySelectorAll(\'#sections option\');';
        $scope.extractSections += 'for (var i = 0; i < s.length; i++) {console.log(s[i].getAttribute(\'value\'));}';

        var getCommuneFromCode = function (code) {
            var result;
            _.forEach($scope.communes.items, function (commune) {
                if (commune.code === code) {
                    result = commune;
                }
            });
            return result;
        };
        var getSectionFromCode = function (code) {
            var result;
            _.forEach($scope.sections.items, function (section) {
                if (section.name === code) {
                    result = section;
                }
            });
            return result;
        };
        $scope.importSections = function () {
            //000AB
            var data;
            var promises = [];
            var commune = $scope.data.commune;
            _.forEach($scope.data.sections.split('\n'), function (id) {
                if (id) {
                    data = {
                        commune: commune,
                        prefix: id.slice(0, 3),
                        name: id.slice(3, 5)
                    };
                    promises.push(
                        swif.data.create('patrimoine_cadastre_section', data)
                    );
                }
            });
            $q.all(promises).then(function () {
                swif.message.addInfo('import successfully');
                $scope.sections.getItems();
            });
        };
        $scope.extractFeuilles = 'var f = document.querySelectorAll(\'#prefixeFeuille option\');';
        $scope.extractFeuilles += 'for (var i = 0; i < f.length; i++) {console.log(f[i].getAttribute(\'value\'));}';
        $scope.importFeuilles = function () {
            //IL084 000 AB01
            //01234 567 89
            //ZT228 000 0A01

            var commune, section, data;
            var promises = [];
            _.forEach($scope.data.feuilles.split('\n'), function (id) {
                if (id) {
                    commune = getCommuneFromCode(id.slice(0, 5));
                    section = getSectionFromCode(id.slice(8, 10));
                    data = {
                        commune: [commune.id, commune.name],
                        section: [section.id, section.name],
                        prefix: id.slice(5, 8),
                        name: id.slice(10, 12),

                    };
                    promises.push(
                        swif.data.create('patrimoine_cadastre_feuille', data)
                    );
                }
            });
            $q.all(promises).then(function () {
                swif.message.addInfo('import successfully');
                $scope.feuilles.getItems();
            });
        };
    }

})();
